export default {
  state: {
    notification: false,
    loading: false,
    error: null,
  },
  mutations: {
    clearError(state) {
      state.error = null;
    },
    setNotificationLoading(state, data) {
      state.loading = data;
      state.error = null;
    },
  },
  actions: {
    requestPermissionNotification() {
      return new Promise((resolve) => {
        Notification.requestPermission().then((result) => {
          resolve(result);
        });
      });
    },
    newStandByTurn({ commit }, value) {
      commit("setNotificationLoading", true);
      if (Notification.permission === "granted") {
        new Notification(value, {
          body: "Nuevo turno en espera",
        });
      }
      commit("setNotificationLoading", false);
      commit("clearError");
    },
    newAssignAutomaticallyTurn({ commit }, value) {
      commit("setNotificationLoading", true);
      if (Notification.permission === "granted") {
        new Notification(value, {
          body: "El turno se te ha asignado automaticamente",
        });
      }
      commit("setNotificationLoading", false);
      commit("clearError");
    },
    stanbyTurns({ commit }, value) {
      commit("setNotificationLoading", true);
      if (Notification.permission === "granted") {
        new Notification(value, {
          body: `Turnos pendientes`,
        });
      }
      commit("setNotificationLoading", false);
      commit("clearError");
    },
  },
};
